<template>
  <div class="UploadFiles d-flex">
    <UploadFilesLeft
      class="UploadFiles_left pa-8"
      :files="files"
      :documentKind="documentKind"
      :documentStatus="documentStatus"
      :isInvalid="isInvalid"
      :isOpened="isOpened"
      @update:documentKind="$emit('update:documentKind', $event)"
      @appendFiles="$emit('appendFiles', $event)"
      @removeFile="$emit('removeFile', $event)"
    />
    <UploadFilesRight
      class="UploadFiles_right"
      :documentKind="documentKind"
    />
  </div>
</template>

<script>
  import UploadFilesLeft from '@/components/ui/common/UploadFiles/UploadFilesLeft'
  import UploadFilesRight from '@/components/ui/common/UploadFiles/UploadFilesRight'

  export default {
    components: {
      UploadFilesLeft,
      UploadFilesRight,
    },
    props: {
      isOpened: {
        type: Boolean,
        default: false,
      },
      document: {
        type: String,
        default: '',
      },
      pages: {
        type: Array,
        default: () => [],
      },
      files: {
        type: Array,
        required: true,
      },
      documentKind: {
        type: String,
        required: true,
      },
      documentStatus: {
        type: String,
        default: '',
      },
      isInvalid: {
        type: Boolean,
        required: true,
      },
    },
    methods: {
      addDropFile(files) {
      // WIP
      },
    },
  }
</script>

<style scoped lang="scss">
.UploadFiles {
  border: 2px solid rgba(121, 137, 183, 0.08);

  &_left {
    flex: 1 0 56%;
    background: white;
  }
  &_right {
    flex: 0 0 44%;
    position: relative;
  }
}
</style>
